<div class="container-fluid">
    <div class="row even-cards">
        <div class="col-12 terminal-container">
            <ng-terminal [xtermOptions]="options" [className]="terminal" #terminal></ng-terminal>
        </div>
    </div>
</div>